var map = {
	"./BannerAprobadaDebidaDiligencia.png": 3084,
	"./BannerDebidaDiligenciaTerminada.png": 9443,
	"./BannerNoAutorizado.png": 7935,
	"./BannerValidacionDebidaDiligencia.png": 2400,
	"./facebook.png": 4141,
	"./logo-aportes-en-linea-retina.png": 9715,
	"./preguntenos.png": 1201,
	"./twitter.png": 1591,
	"./youtube.png": 2307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8288;